'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Notifications;

var _ActionTypes = require('../actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_STATE = {};

function Notifications() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _ActionTypes2.default.ADD_NOTIFICATION:
      return _extends({}, state, _defineProperty({}, action.payload.id, action.payload));
    case _ActionTypes2.default.REMOVE_NOTIFICATION:
      {
        if (state[action.payload.id] == null) return state;

        var nextState = _extends({}, state);
        delete nextState[action.payload.id];
        return nextState;
      }
    default:
      return state;
  }
}
module.exports = exports['default'];